import { InitFeatureParams } from '../types'
import { getRoutes } from './routes'

export const initTeacherManagement = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes())
}
